<template>
  <div class="card-body position-relative overflow-hidden">
    <div class="font-size-36 font-weight-bold text-dark mb-n2">
      {{ number }}
    </div>
    <div class="text-uppercase">{{ title }}</div>
    <div style="position: absolute; top: 0px; right: 0; margin-right: -50px; margin-top: -75px; opacity: 0.1;">
      <v-icon color="primary" size="250">show_chart</v-icon></div>
  </div>
</template>
<script>

export default {
  name: 'SinglChart',
  props: {
    title: {
      type: String,
      default: () => {
        return ''
      }
    },
    number: {
      type: [Number, String],
      default: () => {
        return 0
      }
    }
  },
  data: function () {
    return {
    }
  }
}
</script>
<style src="@/assets/css/bs-helpers.css" lang="css" scoped/>